import { render, staticRenderFns } from "./skew-y.vue?vue&type=template&id=3171c211&"
import script from "./skew-y.vue?vue&type=script&lang=js&"
export * from "./skew-y.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports